import React, { Component, Fragment } from 'react';
import DEFINE, {PATHS, FEATURE_FLAGS} from "../../../../constants/Define";
import * as Func from '../../../../helpers/functions';
import * as HMS from "../../common/component/Index";
import PackageRateList from './PackageRateList';
import Ripple from '../../common/component/Ripple';
import { Button, Modal } from 'antd';
import { isEqual } from 'lodash';
import { Link } from 'react-router-dom';
import RenderHotelisActive from '../Hotels/HotelList/RenderHotelisActive';

let permisionActions = [];
export default class PackageRate extends Component {
    constructor(props) {
        super(props);
        this.state = {
            filters: {},
            PackageRates: [],
        };
        this.ChildElement = React.createRef();
    }

    componentDidMount() {
        permisionActions = Func.getPermissionActions(DEFINE.GENERAL.ROUTE_NAME.PACKAGERATES);
        this.props.getListPackageRates(this.state.filters);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.packageRateState && !isEqual(nextProps.packageRateState.dataList, this.props.packageRateState.dataList)) {
            this.setState({ PackageRates: nextProps.packageRateState.dataList });
        }
    }

    showConfirmSync = () => {
    }

    onChangeHotel = (e) => {
        const newFilters = {...this.state.filters, hotelId: e};
        this.setState({filters: newFilters});
        this.props.getListPackageRates(newFilters);
    }
    
    render() {
        const { t } = this.props;
        const { isFetching, totalCount, totalPage, pageIndex, pageSize } = this.props.packageRateState;
        const { PackageRates } = this.state;
        const pagination = { totalCount, totalPage, defaultCurrent: pageIndex, pageSize };

        return (
            <Fragment>
                <HMS.PageListComponent onChangeLanguage={FEATURE_FLAGS.TRANSLATE_ENABLE && this.onChangeLanguage} className="package-rate-listing">
                    <HMS.HeaderListComponent
                        path={this.props.match.path}
                        groupPath={'PackageRate'}
                        titleHeader={t('navigation.packageRate')}
                        componentRight={
                            <div className='d-flex'>
                                <RenderHotelisActive defaultOptionLabel="Tất cả khách sạn" onChangedHotel={this.onChangeHotel} />
                                {
                                    permisionActions && permisionActions.allowCreate && (
                                        <Ripple color="rgba(255, 255, 255, 0.8)" waitForEffect={true}>
                                            <Link to={PATHS.PACKAGE_RATE.CREATE.path}
                                                className='btn btn-primary'>+ {t(`action.create`)}</Link>
                                        </Ripple>
                                    )
                                }
                            </div>
                        }
                    />
                    <PackageRateList 
                        getListRates={() => this.props.getListRates(this.state.filters)}
                        loading={isFetching}
                        pagination={pagination}
                        permissions={permisionActions}
                        dataList={PackageRates}
                        onChange={this.onTableChange}
                        updatePackageRateActive={this.props.updatePackageRateActive}
                        deletePackageRate={(id) => this.props.deletePackageRate(id, this.state.filters)}
                        clonePackageRate={(id) => this.props.clonePackageRate(id, this.state.filters)}
                        />
                </HMS.PageListComponent>
            </Fragment>
        );
    }

    onTableChange = (pagination, filters, sorter) => {
        let newFilters = {...Func.genaratePaginateFilterSort(pagination, filters, sorter), hotelId: this.state.filters?.hotelId};
        this.setState({filters: newFilters});
        this.props.getListPackageRates(newFilters);
    };
}